/*
Notes:产品列表ajax Api
Date:2018/8/31 by zenglihuai
*/

import ajax from "./ajax"; //引用二次封装ajax.js

export default {
  //产品类别列表数据
  getProductCategoryList: function(params) {
    return ajax.postForm(
      "/loanform/base/loanBaseProduct/getProductCategoryList.ht",
      params
    );
  },

  //产品列表数据
  getProductListData: function(params) {
    return ajax.postForm(
      "/loanform/base/loanBaseProduct/getProductList.ht",
      params
    );
  }
};



// WEBPACK FOOTER //
// ./src/api/products.js